import { OccurrenceSlotResponse } from "../contracts/OccurrenceSlotResponse";
import { OccurrenceSlot } from "../models/OccurrenceSlot";

/** The wire slot to a model; null stays null. */
export const toOccurrenceSlot = (response: OccurrenceSlotResponse | null): OccurrenceSlot | null =>
  response ? { startsAt: new Date(response.startsAt), timeZone: response.timeZone } : null;
